'use strict';

/* SCROLLING NAVBAR */
var OFFSET_TOP = 100;
var LAST_OFFSET = 0;

$(window).on('scroll', _.debounce(function() {
    let navbar = $('.navbar');

    //  console.log('', 'navbar',navbar.offset().top);
    if (navbar.length > 0) {
        let topPosition = navbar.offset().top;

        let hideNav = topPosition > OFFSET_TOP,
            scrolling_navbar = $('.scrolling-navbar');
        //      console.log('topPosition',topPosition,'LAST_OFFSET',LAST_OFFSET,'scrollingDown',scrollingDown, 'topPosition > OFFSET_TOP',topPosition > OFFSET_TOP);

        if (hideNav) {
            // we changed direction moving up
            if (LAST_OFFSET > topPosition) {
                if (scrolling_navbar.hasClass('top-nav-collapse')) {
                    scrolling_navbar.removeClass(['top-nav-collapse', 'scrolling-navbar--collapse']);
                }
            } else if (!scrolling_navbar.hasClass('top-nav-collapse')) {
                scrolling_navbar.addClass(['top-nav-collapse', 'scrolling-navbar--collapse']);
            }

        } else if (scrolling_navbar.hasClass('top-nav-collapse')) {
            scrolling_navbar.removeClass(['top-nav-collapse', 'scrolling-navbar--collapse']);
        }
        LAST_OFFSET = topPosition;
    }
}, 100));



// WEBPACK FOOTER //
// ./resources/assets/vendor/MDB Pro 4.4.3/js/modules (optional)/scrolling-navbar.js